import React from "react";

import { useNavigate } from "react-router-dom";
import { addToCheckouts, checkoutSession } from "../../actions/storeActions";
import uuid from "uuid/dist/v4";
import { useDispatch } from "react-redux";

const FeeDetail = ({
  checkoutProducts,
  earnedPoints,
  eachProductPiecesLeft,
  service,
  setCartData,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let totalItem = 0;
  let totalPrice = 0;
  let totalProduct = [];
  let productIds = [];
  let orderId = uuid();
  let totalPoints = 0;
  let cardDataNeeded = [];
  //summarizing all data from bag
  checkoutProducts.forEach((data) => {
    const { price, total, _id, points } = data;
    totalItem += total;
    totalPrice += price * total;
    totalProduct.push(total);
    productIds.push(_id);
    totalPoints += points * total;
    cardDataNeeded.push({ _id: _id, total: total });
  });

  const handleAddToCheckouts = async () => {
    dispatch({ type: "REMOVE_ITEMS", payload: { productIds, totalItem } });
    dispatch({
      type: "SET_CANVAS",
      payload: { openCanvas: true, message: "Processing order..." },
    });

    const response = await addToCheckouts({
      data: {
        productIds,
        orderId,
        totalProduct,
        totalPrice: totalPrice.toFixed(2),
        eachProductPiecesLeft,
        service,
        totalPoints: totalPoints.toFixed(2),
      },
    });

    window.location.href = `/cart/checkout/${orderId}`;
    if (response.param === "success") {
      navigate(`/cart/checkout/${orderId}`);
    }
  };
  return (
    <>
      <div className="points_details">
        <p className="detail_header">Points Earned</p>
        <div className="detail">
          <p>Total points: {totalPoints}</p>
        </div>
      </div>
      <div className="fee_and_order_btn">
        <div className="total_price">
          <div className="total_fee">
            P{totalPrice ? totalPrice.toFixed(2) : "0"}
          </div>
          <div className="shipping_fee">Service Fee: {service.rate}</div>
        </div>
        <div>
          <button
            disabled={checkoutProducts.length <= 0}
            className="checkout_btn"
            onClick={() => handleAddToCheckouts()}
          >
            Place Order
          </button>
        </div>
      </div>
    </>
  );
};

export default FeeDetail;
